import { useEffect } from 'react';
import { useThemeStore } from '@/store/theme-store';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
	const { theme, colorMode } = useThemeStore();

	useEffect(() => {
		// Ensure theme is applied on mount and whenever it changes
		const applyThemeClass = (theme: string, colorMode: string) => {
			const body = document.body;
			
			// Remove all existing theme classes
			const themeClasses = [
				'earthy-light', 'earthy-dark',
				'forest-light', 'forest-dark', 
				'air-light', 'air-dark',
				'sea-light', 'sea-dark',
				'midnight-light', 'midnight-dark'
			];
			
			body.classList.remove(...themeClasses);
			
			// Apply the new theme class
			const themeClass = `${theme}-${colorMode}`;
			body.classList.add(themeClass);
			
			console.log(`🎨 ThemeProvider applied theme class: ${themeClass}`);
		};

		applyThemeClass(theme, colorMode);
	}, [theme, colorMode]);

	return <>{children}</>;
}